import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { MetricsProvider } from './contexts/MetricsContext';
import Navbar from './components/Navbar';
import MetricsSection from './components/MetricsSection';
import Login from './components/Login';
import PublicStatusPage from './components/PublicStatusPage';
import './App.css';

function AdminContent() {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Login />;
  }

  return (
    <div className="App">
      <Navbar />
      <MetricsSection />
    </div>
  );
}

function AppContent() {
  // Check for admin mode via URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const isAdminMode = urlParams.get('admin') === 'true';

  if (isAdminMode) {
    return (
      <AuthProvider>
        <MetricsProvider>
          <AdminContent />
        </MetricsProvider>
      </AuthProvider>
    );
  }

  // Public status page (no authentication required)
  return <PublicStatusPage />;
}

function App() {
  return <AppContent />;
}

export default App;
